import { Link } from "react-router-dom"
import Transporter from "./Transporter"
import TransporterTypeSelector from "./TransporterTypeSelector"
import { FormattedMessage } from "react-intl"
import withI18n from "../i18n/withI18n"
import Layout from "./Layout"

class SearchResult extends React.Component {
  state = {
    transporterType: this.props.location.state.dimensions.transporterType,
    containerType: this.props.location.state.dimensions.containerType,
  }

  toggleTransporterType = () => {
    this.setState({
      transporterType: this.newTransporterType(),
    })
  }

  newTransporterType = () => {
    return this.state.transporterType === "bags" ? "boxes" : "bags"
  }

  updateLanguage = (event) => {
    this.props.updateLanguage(event.target.value)
  }

  render() {
    const { location, languages, locale } = this.props
    let {
      width,
      height,
      length,
      count,
      measurement,
      foodPanDescription,
      containerDescription,
    } = location.state.dimensions

    measurement = measurement === "imperial" ? "in" : "cm"

    const hasResult =
      typeof location.state !== typeof undefined &&
      (location.state.boxes.length > 0 || location.state.bags.length > 0)

    const transporterResults = location.state[this.state.transporterType] ?? []
    const hasTransporterResult = transporterResults.length > 0

    const sidebarMsg =
      this.state.containerType === "container"
        ? containerDescription
        : foodPanDescription

    const sidebarMessage = (
      <FormattedMessage
        id="togo.search_results.your_togo_container"
        values={{
          containerDescription: sidebarMsg,
        }}
      />
    )

    return (
      <div className="container-fluid">
        <Layout
          languages={languages}
          handler={this.updateLanguage}
          locale={locale}
        />
        <div className="col-sm-3 left-page">
          <img
            src={`/assets/logo_togo-container-solution-${this.props.locale}.jpg`}
            className="img-responsive center-block logo hidden-xs"
          />
          <img
            src={`/assets/logo_togo-container-solution-mobile-${this.props.locale}.jpg`}
            className="img-responsive center-block visible-xs"
          />

          {hasResult && (
            <div>
              <br />
              <div className="col-md-5 hidden-xs">
                <br />
                <img
                  src={
                    this.state.containerType === "container"
                      ? "/assets/gobag_togo-box.png"
                      : "/assets/gobag-icon_food-pan.png"
                  }
                  className="img-responsive center-block"
                />
                <br />
              </div>
              <div className="col-md-7 text-left hidden-xs">
                <div className="togo-title">{sidebarMessage}:</div>
                <div className="togo-label">
                  <FormattedMessage id="togo.measurement_labels.width.title" />:{" "}
                  <span className="togo-size">
                    {width} {measurement}
                  </span>
                </div>
                <div className="togo-label">
                  <FormattedMessage id="togo.measurement_labels.length.title" />
                  :{" "}
                  <span className="togo-size">
                    {length} {measurement}
                  </span>
                </div>
                <div className="togo-label">
                  <FormattedMessage id="togo.measurement_labels.height.title" />
                  :{" "}
                  <span className="togo-size">
                    {height} {measurement}
                  </span>
                </div>
                {count && (
                  <div className="togo-label">
                    <FormattedMessage id="togo.measurement_labels.quantity.title" />
                    : <span className="togo-size">{count}</span>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
        <div className="col-sm-9 right-page">
          <Link
            className="btn-restart"
            to={{
              pathname:
                window.location.pathname == "/togo-don/search"
                  ? "/togo-don"
                  : "/togo/",
              state: { locale: this.props.locale },
            }}
          >
            <FormattedMessage id="togo.search_results.actions.size_another_container" />
          </Link>
          <TransporterTypeSelector
            toggleTransporterType={this.toggleTransporterType}
            selected={this.state.transporterType}
          />
          <br />
          <br />
          {!hasResult && <h2>No search results</h2>}
          {!hasTransporterResult && hasResult && (
            <h2>No search results for {this.state.transporterType}</h2>
          )}
          {hasResult &&
            transporterResults.map((transporter) => (
              <Transporter
                key={transporter.id}
                transporter={transporter}
                containerType={this.state.containerType}
              />
            ))}
        </div>
      </div>
    )
  }
}

SearchResult.defaultProps = {
  languages: {
    de: "German",
    en: "English",
    fr: "French",
    ru: "Russian",
  },
}

export default withI18n(SearchResult)
